import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

/**
 * Skeleton — placeholder pulsante para loading states (D15 do briefing).
 * Cópia direta do shadcn (sem Radix, sem dependência extra).
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
